import { useEffect } from "react";
import StepComplete from "../../../components/common/stepComplete/StepComplete";
import AppHeader from "../../../components/common/appHeader/AppHeader";
import { useDispatch } from "react-redux";
import { setIsComplete } from "@src/@slice/recommendHallSlice";

import { HOSTNAME, isExternalUrl } from "@src/utils";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import { closeWebview } from "@src/utils/route";

const Complete = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsComplete({ bool: true }));
  }, []);

  return (
    <div className="recommend-hall-complete">
      {/* <AppHeader type="nonStack" actionItems={[{ name: "close" }]} /> */}
      <CustomHeader goBack={closeWebview} close={closeWebview} />
      {/* <AppHeader type="stack" actionItems={[{ name: "close" }]} headerPostion="fixed" /> */}
      <div className="complete-circle">
        <i className="icon icon-22 icon-check-white" />
      </div>
      <StepComplete
        title={`신청이 완료되었습니다.`}
        text={`희망 조건에 딱 맞는 웨딩홀 추천 리스트를
          알림톡과 웨딩북 채팅창으로 곧 보내드릴게요.`}
      />

      <p className="complete-sub-text">*더 정밀한 추천을 위해 담당자가 해피콜을 드릴 수 있어요.</p>
      <div className="gradient-background"></div>
      <button
        className="btn btn-full btn-red500 btn-giant"
        onClick={() =>
          (window.location.href = isExternalUrl(`${HOSTNAME}/weddinghall/search?hidetab=true`))
        }
      >
        웨딩홀 더 알아보기
      </button>
      {/* </div> */}
    </div>
  );
};

export default Complete;
